import { Select } from "antd";
import React, { useState, useEffect } from "react";
import axios from "axios";

const endPoint =
  process.env.REACT_APP_API_URL || new URL(window.location.href).origin;

const { Option } = Select;

const fetch = (table, col, val, op, callback) => {
  axios
    .get(`${endPoint}/api/${table}?filter=[${col}:${val}:${op}]`)
    .then((response) => {
      callback(response.data.items);
    })
    .catch((error) => {
      console.log(error);
    });
};

const SearchInput = (props) => {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);
  const { onChange, value } = props;

  // Filtre dışarıdan temizlendiğinde seçimi sıfırla, dışarıdan bir id ile
  // geldiğinde (ör. URL'deki filtre) kaydın adını çekip etiketi göster
  useEffect(() => {
    if (value === null || value === "" || typeof value === "undefined") {
      setSelected(null);
      return;
    }

    if (selected && String(selected.value) === String(value)) {
      return;
    }

    axios
      .get(`${endPoint}/api/${props.table}?filter=[id:${value}:eq]`)
      .then((response) => {
        const item = response.data.items?.[0];
        if (item) {
          setSelected({ value: item.id, label: item.name });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleSearch = (val) => {
    if (val) {
      fetch(props.table, props.col, val, props.op, setData);
    } else {
      setData([]);
    }
  };

  const handleChange = (val) => {
    setSelected(val || null);
    onChange(
      val ? data.filter((item) => item.id === parseInt(val.value))[0] : null
    );
  };

  const options = data.map((d) => (
    <Option value={d.id} key={d.id}>
      {d.name}
    </Option>
  ));

  return (
    <Select
      showSearch
      labelInValue
      allowClear
      value={selected}
      placeholder="Aramak için yazın..."
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      notFoundContent={null}
      className={props.className}
      style={props.style}
    >
      {options}
    </Select>
  );
};

export default SearchInput;
